import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import YJTD from '../views/YJTD.vue'
import YJXX from '../views/YJXX.vue'
import Workspace from '../views/Workspace.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/yjtd',
    name: 'YJTD',
    component: YJTD
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/yjxx',
    name: 'YJXX',
    component: YJXX
  },
  {
    path: '/workspace',
    name: 'Workspace',
    component: Workspace
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
